import { render, staticRenderFns } from "./DormForm.vue?vue&type=template&id=dab83292&"
import script from "./DormForm.vue?vue&type=script&lang=js&"
export * from "./DormForm.vue?vue&type=script&lang=js&"
import style0 from "./DormForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports